import { useMemo } from 'react';
import { Props as ReactApexChartProps } from 'react-apexcharts';
import { useLang } from '../../../../../../hooks/use-lang';
import { useDashboardStore } from '../../../../../../store/use-dashboard-store';
import { ChartProps } from '../../dashboard-components/dashboard-charts/use-dashboard-charts';

interface DataType {
  counts: number[];
}

const ratings = [1, 2, 3, 4, 5];

export const useTasksByRating = (): ChartProps => {
  const { t } = useLang();
  const { list } = useDashboardStore();
  const data = list?.tasks_by_rating as DataType;

  const chartData = useMemo<ReactApexChartProps>(() => {
    if (data?.counts) {
      const isDataExist = data.counts.some((count) => count > 0);
      const total = data.counts.reduce((acc, count) => acc + count, 0);

      return {
        series: isDataExist ? data.counts : undefined,
        options: {
          chart: {
            type: 'donut',
            toolbar: {
              show: false,
            },
          },
          labels: ratings.map((rating) => {
            if (rating === 1) {
              return `${rating} ${t('звезда')}`;
            }
            if (rating >= 2 && rating <= 4) {
              return `${rating} ${t('звезды')}`;
            }
            return `${rating} ${t('звезд')}`;
          }),
          dataLabels: {
            enabled: false,
          },
          tooltip: {
            y: {
              formatter(val) {
                return `${val} (${((val / total) * 100).toFixed(2)}%)`;
              },
            },
          },
          legend: {
            position: 'bottom',
            inverseOrder: true,
          },
          colors: ['#FF5722', '#FF9800', '#FFC107', 'hsl(180, 100%, 40%)', 'hsl(90, 100%, 40%)'],
          yaxis: {},
          xaxis: {},
        },
      };
    }

    return {
      series: [],
      options: {},
    };
  }, [data, t]);

  return {
    series: chartData.series,
    options: chartData.options,
    type: 'donut',
    label: 'Распределение задач по оценкам',
    subLabel:
      'Отчёт отражает долю задач с разными оценками, упрощая приоритизацию и планирование ресурсов.',
    wrapped: true,
  };
};
